import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'documents/document';
const wizardName = 'Personal picture association';
const wizardObject = 'Personal Picture';
const wizardAction = 'personalPictureAssociation';

const PersonalPictureAssociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [ drawable, setDrawable ] = useState(true);

    const { save, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, true);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const modelName = existingModules.modelName
    const detailConfig = {
        "tabs": [
            {
                "name": "document",
                "fieldsets": [
                    {
                        "name": "document",
                        "fields": {
                            "file": {
                                "type": "dropzone",
                                "className": "col-12",
                                "icon": "faFile"
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            close();
        }
    }, [success]);

    const handleSave = async (data) => {
        save && save({ ...data, filters: params.filters })
    }

    const person = discover('person');
    console.info('car prima di detailcomponent', person, person?._id)

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    "person_id": person?._id,
                    "type": "personalPicture",
                    "visibleToDriver": "true",
                    "name": t("Picture ") + (person?.lastname ? ' ' + person?.lastname : '')
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Add a {{wizardObject}} to {{firstname}} {{lastname}}', { wizardObject: wizardObject, firstname: person?.firstname, lastname: person?.lastname })}
                    />
                }
                {...params}
            />
    )
}

export default PersonalPictureAssociation;


